export { default } from "./src/customer-stories-details-hero";
export type { UniformCustomerStoriesDetailsHeroProps } from "./src/customer-stories-details-hero";
export type { UniformCustomerStoriesDetailsHeroQuoteProps } from "./src/customer-stories-details-hero-quote";
